import Footer from './Footer';
import Topbar from './Topbar';
import './App.css';
import { useParams } from 'react-router-dom';

const MyIframe = ({ url, ...props }) => {
    return <iframe title="insights" src={url} {...props} />;
};

export default function Insights() {
    const { blogref } = useParams();
    const subdomainUrl = `https://insights.binaryinventions.com/blog/${blogref}`; // Replace with your subdomain
    
    console.log(blogref);
    return (
        <div>
            <Topbar />
            {/* if {blogref} is not null, then render the following: */}
            {blogref ? (
                <MyIframe url={subdomainUrl}/>
            ) : (
                <MyIframe url="https://insights.binaryinventions.com/blog/stl-tech-week-day1"/>
            )} 
            <Footer />

        </div>     
    )
}